var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragAndDrop3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49724 17.5059C8.22212 17.5059 7.99703 17.731 8.00003 18.0061C8.00003 18.2812 8.22512 18.5063 8.50024 18.5063C8.77535 18.5063 9.00045 18.2812 9.00045 18.0061C9.00045 17.731 8.77535 17.5059 8.49724 17.5059",
    stroke: "#C3C3C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49724 11.502C8.22212 11.502 7.99703 11.727 8.00003 12.0022C8.00003 12.2773 8.22512 12.5024 8.50024 12.5024C8.77535 12.5024 9.00045 12.2773 9.00045 12.0022C9.00045 11.727 8.77535 11.502 8.49724 11.502",
    stroke: "#C3C3C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49724 5.5C8.22212 5.5 7.99703 5.72509 8.00003 6.00021C8.00003 6.27532 8.22512 6.50042 8.50024 6.50042C8.77535 6.50042 9.00045 6.27532 9.00045 6.00021C9.00045 5.72509 8.77535 5.5 8.49724 5.5",
    stroke: "#C3C3C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4972 17.5059C14.2221 17.5059 13.997 17.731 14 18.0061C14 18.2812 14.2251 18.5063 14.5002 18.5063C14.7754 18.5063 15.0004 18.2812 15.0004 18.0061C15.0004 17.731 14.7754 17.5059 14.4972 17.5059",
    stroke: "#C3C3C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4972 11.502C14.2221 11.502 13.997 11.727 14 12.0022C14 12.2773 14.2251 12.5024 14.5002 12.5024C14.7754 12.5024 15.0004 12.2773 15.0004 12.0022C15.0004 11.727 14.7754 11.502 14.4972 11.502",
    stroke: "#C3C3C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4972 5.5C14.2221 5.5 13.997 5.72509 14 6.00021C14 6.27532 14.2251 6.50042 14.5002 6.50042C14.7754 6.50042 15.0004 6.27532 15.0004 6.00021C15.0004 5.72509 14.7754 5.5 14.4972 5.5",
    stroke: "#C3C3C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragAndDrop3);
export default __webpack_public_path__ + "static/media/DragAndDrop3.21dd8faa1c9cd1fa7182dfd7a6ec7b9e.svg";
export { ForwardRef as ReactComponent };